import React, { useState } from 'react';
 import { Col, Container, Row } from 'react-bootstrap';
 import { useDispatch } from 'react-redux';

import { IItemCards } from '../../../models/try2Combo';
import { itemBuckets } from '../../../priceCalculation/buckets';
import { removeTry2ComboIngredients } from '../../../redux/slices/itemCustomizationSlice';
import Try2CustomizationModal from '../Customization/try2CustomizationModal';
import styleClasses from '../try2.module.scss';
import ItemCard from './MakeASelection/ItemCards';
import ItemDetail from './MakeASelection/ItemDetails';
import MenuLink from './MakeASelection/MenuLink';

const MakeASelection: React.FC<IItemCards> = (props) => {
  const {
    sectionSelected,
    setSectionSelected,
    order,
    itemFromApi,
    itemDetails,
    selectedItem,
    onRemoveClickHandler,
    handleIngredientSelection,
    handleSyncIngredients,
    category,
    noDressingHandler,
    selectedLocation,
    DescriptionScrollRef
  } = props;

  const dispatch = useDispatch();
  const [ingredientsModal, setIngredientsModal] = useState<boolean>(true);
  const [loadValueForModal, setLoadValueForModal] = useState<{
    load: boolean;
    name: string;
    id: string;
  }>(null);
  
  const showIngredientsModalHandler = () => {
    itemBuckets.createBucketCopy();
    setIngredientsModal(true);
  };

  const hideIngredientsModalHandler = () => {
    setIngredientsModal(false);
    setLoadValueForModal({ load: false, name: null, id: null });
  };

  const onEditClickHandler = (name: string, id: string) => {
    setLoadValueForModal({ load: true, name, id });
    showIngredientsModalHandler();
  };
  const addCustomizeItemtoComboClick = () => {};

  const findSelectedItem = () => {
    const id = loadValueForModal?.name;
    const item = order.modifiers.filter((item) => item.name === id);
    const category: any = itemFromApi.sub_categories.filter(
      (category) => category.id === parseInt(item[0]?.category_id)
    );
    const a = category[0].items.filter((obj) => obj.id === item[0].id);
    return a[0];
  };

  const selectedOrder = () => {
    let result = [];
    order.modifiers.map((itemModifier) => {
      if (itemModifier.name === loadValueForModal?.name) {
        result = itemModifier;
      }
    });
    return result;
  };

  const selectedIngredients = (orderItem) => {
    return orderItem.modifiers;
  };

  const removeSelectedIngredients = (selectedCustomizeData, id) => {
    dispatch(
      removeTry2ComboIngredients({
        modifiers: selectedCustomizeData,
        sectionSelected: loadValueForModal?.id,
        order,
      })
    );
  };

  return (
    <>
      <Container
        className={
          itemDetails ? "try2_pane_wrap px-0 px-md-3" : "mt-4 mt-md-0 px-0 px-md-3"
        }
      >
        <Row className="justify-content-center mx-0 mx-md-n3">
          <Col lg="9" className="px-0 px-md-3">
            <div className="text-start d-md-none">
              <MenuLink />
            </div>
            <div className={`${styleClasses.inner_content_wrap} text-start`}>
              {/* {itemDetails && (
                <h5 className="text-uppercase f-sm-s18 mb-4 ls-sm-normal text-start">
                  TRY 2 COMBO
                </h5>
              )} */}
              <Row className="pt-md-3 justify-content-center try2-require-items-wrap">
                <ItemCard
                  setSectionSelected={(id, scroll) => {
                    setSectionSelected(id,scroll);
                  }}
                  order={order}
                  itemFromApi={itemFromApi}
                  itemDetails={itemDetails}
                  selectedItem={selectedItem}
                  sectionSelected={sectionSelected}
                  onRemoveClickHandler={onRemoveClickHandler}
                  onEditClickHandler={onEditClickHandler}
                  showIngredientsModalHandler={showIngredientsModalHandler}
                />
              </Row>
              <Row className='pt-3' ref={DescriptionScrollRef}>
                <ItemDetail
                  itemDetails={itemDetails}
                  originalPrice={itemFromApi?.price}
                  price={order?.display_price}
                  description={category?.description}
                  name={category?.name}
                  selectedLocation={selectedLocation}
                />
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
      {loadValueForModal?.load && ingredientsModal && (
        <Try2CustomizationModal
          showCustomizationModal={ingredientsModal}
          closeCustomizationModal={hideIngredientsModalHandler}
          modifierGroups={findSelectedItem()?.items_modifier_groups}
          coreModifiers={findSelectedItem()?.core_modifiers}
          requiredModifiers={findSelectedItem()?.items_required_modifier_groups}
          handleIngredientSelection={(modifier) =>
            handleIngredientSelection(modifier, loadValueForModal?.id)
          }
          itemName={findSelectedItem()?.name}
          isCreateYourOwnItem={findSelectedItem()?.is_create_your_own}
          addItemtoComboClick={addCustomizeItemtoComboClick}
          handleSyncIngredients={handleSyncIngredients}
          selectedItem={findSelectedItem()}
          sectionSelected={sectionSelected}
          selectedIngredients={selectedIngredients(selectedOrder())}
          removeSelectedIngredients={removeSelectedIngredients}
          currentEditItem={loadValueForModal?.id}
          noDressingHandler={noDressingHandler}
          isItEdit={true}
        />
      )}
    </>
  );
};

export default MakeASelection;
